import loadable from '@loadable/component';

export const GetpriceSiteWrapper = loadable(
  () => import(/* webpackChunkName: "getprice-site" */ './GetpriceSiteWrapper'),
);
